import { NodeWithMultipleHandles } from '../NodeWithMultipleHandles';

const SmtpNode = (props) => {
    return <NodeWithMultipleHandles {...props} nodeType="smtp" />;
};

export default SmtpNode;
